import FixedImage from './components/FixedImage'
import NextImage from './NextImage'

export { FixedImage }
export default NextImage
